import React from 'react';
import './_configurationBot.scss';
import { injectIntl } from 'react-intl';
import CapHeading from '../../CapHeading';
import CapRow from '../../CapRow';
import IdentityIcon from './IdentityIcon';
import { IDENTITY_ICON_TYPES } from './constants';

const UserRequest = ({
  intl: { formatMessage },
  message,
  firstName,
  lastName,
}) => {
  message = message.trim();
  const actionPrefix = 'action:';
  if (message.startsWith(actionPrefix)) {
    let encoded = message.slice(actionPrefix.length);
    encoded = encoded.slice(0, 4) + '...' + encoded.slice(-8);
    message = 'Encoded Action: ' + encoded;
  }
  return (
    <CapRow type="flex" className="user-request-container">
      <IdentityIcon
        iconType={IDENTITY_ICON_TYPES.HUMAN}
        firstName={firstName || 'U'}
        lastName={lastName || 'S'}
      />
      <CapHeading type="h8" className="user-request-description">
        {message}
      </CapHeading>
    </CapRow>
  );
};

UserRequest.defaultProps = {};
export default injectIntl(UserRequest);
